module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_5012.208a0f57.png";